import { ProfileMin } from '../shared/profile-min.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileSearchService, ProfileSearchParams, ProfileSearchResult } from '../search/index';
import { ProfileService } from '../shared/profile.service';
import { PagedResultGeneric as PagedResult } from '../../shared/model/paged-result.model';

@Component({
  selector: 'wl-profile-quicksearch',
  templateUrl: './profile-quicksearch.component.html',
  styleUrls: ['./profile-quicksearch.component.css'],
  providers: [ProfileSearchService],
  standalone: false
})
export class ProfileQuicksearchComponent implements OnInit {
  private _profileSearchService: ProfileSearchService;
  private _profileService: ProfileService;
  private _keywordValue: string;

  public searchParams: ProfileSearchParams;
  public searchResults: PagedResult<ProfileMin>;
  public isSearching = false;

  @Input()
  get Keyword() {
    return this._keywordValue;
  }
  set Keyword(val) {
    this._keywordValue = val;
    this.keywordChange.emit(this._keywordValue);
    if (!this.suppressAutoSearch) {
      this.search();
    }
  }
  @Input() suppressAutoSearch: boolean;

  @Output() keywordChange = new EventEmitter();
  @Output() searchComplete = new EventEmitter();
  @Output() enterPressed = new EventEmitter<string>();

  constructor(profileSearchService: ProfileSearchService, profileService: ProfileService) {
    this._profileSearchService = profileSearchService;
    this._profileService = profileService;
    this._keywordValue = '';
    this.searchParams = new ProfileSearchParams();
  }

  ngOnInit() {}

  public search() {
    if (this.Keyword.length >= 3 && !this.isSearching) {
      this.isSearching = true;

      this.searchParams.Keyword = this.Keyword;

      this._profileSearchService.search(this.searchParams).then((data: ProfileSearchResult) => {
        this.searchResults = data;
        this.isSearching = false;

        if (this.Keyword && this.Keyword !== this.searchParams.Keyword) {
          this.search();
        } else {
          this.searchComplete.emit(this.searchResults);
        }
      });
    }
  }

  public reset() {
    this.searchParams = new ProfileSearchParams();
    this.searchResults = new ProfileSearchResult();
    this.Keyword = '';
    this.isSearching = false;
    this.searchComplete.emit(this.searchResults);
  }
}
